import {
  ModalBaseProps as MantineModalBaseProps,
  ModalBase as MantineModalBase,
  ModalBaseBodyProps as MantineModalBaseBodyProps,
  ModalBaseBody as MantineModalBaseBody,
  ModalBaseCloseButtonProps as MantineModalBaseCloseButtonProps,
  ModalBaseCloseButton as MantineModalBaseCloseButton,
  ModalBaseContentProps as MantineModalBaseContentProps,
  ModalBaseContent as MantineModalBaseContent,
  ModalBaseHeaderProps as MantineModalBaseHeaderProps,
  ModalBaseHeader as MantineModalBaseHeader,
  ModalBaseOverlayProps as MantineModalBaseOverlayProps,
  ModalBaseOverlay as MantineModalBaseOverlay,
  ModalBaseTitleProps as MantineModalBaseTitleProps,
  ModalBaseTitle as MantineModalBaseTitle,
} from '@mantine/core';

export type ModalBaseProps = MantineModalBaseProps;
export type ModalBaseBodyProps = MantineModalBaseBodyProps;
export type ModalBaseCloseButtonProps = MantineModalBaseCloseButtonProps;
export type ModalBaseContentProps = MantineModalBaseContentProps;
export type ModalBaseHeaderProps = MantineModalBaseHeaderProps;
export type ModalBaseOverlayProps = MantineModalBaseOverlayProps;
export type ModalBaseTitleProps = MantineModalBaseTitleProps;

export const ModalBase = MantineModalBase;
ModalBase.displayName = 'ModalBase';

export const ModalBaseBody = MantineModalBaseBody;
ModalBaseBody.displayName = 'ModalBaseBody';

export const ModalBaseCloseButton = MantineModalBaseCloseButton;
ModalBaseCloseButton.displayName = 'ModalBaseCloseButton';

export const ModalBaseContent = MantineModalBaseContent;
ModalBaseContent.displayName = 'ModalBaseContent';

export const ModalBaseHeader = MantineModalBaseHeader;
ModalBaseHeader.displayName = 'ModalBaseHeader';

export const ModalBaseOverlay = MantineModalBaseOverlay;
ModalBaseOverlay.displayName = 'ModalBaseOverlay';

export const ModalBaseTitle = MantineModalBaseTitle;
ModalBaseTitle.displayName = 'ModalBaseTitle';
